const presetGenerators = {
  text: {
    fs: val => `font-size: ${val};`,
    lh: val => `line-height: ${val};`,
    tt: val => `text-transform: ${val};`,
    td: val => `text-decoration: ${val};`,
  },
  fontWeights: {
    fw: val => `font-weight: ${val};`,
  },
  space: {
    mb: val => `margin-bottom: ${val};`,
    mt: val => `margin-top: ${val};`,
    ml: val => `margin-left: ${val};`,
    mr: val => `margin-right: ${val};`,
    mx: val => `margin-left: ${val}; margin-right: ${val};`,
    my: val => `margin-top: ${val}; margin-bottom: ${val};`,
    m: val => `margin: ${val};`,
    pb: val => `padding-bottom: ${val};`,
    pt: val => `padding-top: ${val};`,
    pl: val => `padding-left: ${val};`,
    pr: val => `padding-right: ${val};`,
    px: val => `padding-left: ${val}; padding-right: ${val};`,
    py: val => `padding-top: ${val}; padding-bottom: ${val};`,
    p: val => `padding: ${val};`,
    w: val => `width: ${val};`,
    h: val => `height: ${val};`,
    maxw: val => `max-width: ${val};`,
    maxh: val => `max-height: ${val};`,
    minw: val => `min-width: ${val};`,
    minh: val => `min-height: ${val};`,
  },
  colors: {
    color: val => `color: ${val};`,
    bg: val => `background-color: ${val};`,
  },
}

const unitless = ['color', 'bg', 'fw', 'lh', 'tt', 'td']
const getPropValue = (key, val, presets, debug) => {
  // if (debug) {
  //   console.log(key, val, presets)
  // }
  if (presetGenerators.text[key]) {
    return [presets.text[val] || val, 'text']
  }
  if (presetGenerators.fontWeights[key]) {
    return [presets.fontWeights[val] || val, 'fontWeights']
  }
  if (presetGenerators.space[key]) {
    return [presets.space[val] || val, 'space']
  }
  if (presetGenerators.colors[key]) {
    return [presets.colors[val] || val, 'colors']
  }
  return []
}

const parseProp = (raw, key) => {
  if (unitless.indexOf(key) > -1) {
    return { value: raw, unit: '' }
  }
  const rx = /(\d*\.?\d*)(\S*)/
  const [, value, unit] = rx.exec(raw)
  return { value, unit: unit || 'px' }
}

const getProp = (key, val, presets, index, debug) => {
  if (!val) {
    return ''
  }
  // if (debug) {
  //   console.log(key, val, presets)
  // }
  const [propValue, propType] = getPropValue(key, val, presets, debug)

  if (!propValue) {
    return ''
  }

  const prop = parseProp(Array.isArray(propValue) ? propValue[index] : propValue, key)
  // if (debug) {
  //   console.log(propValue, prop)
  // }
  return presetGenerators[propType][key](`${prop.value}${prop.unit}`)
}

const getFluidProp = (key, val, presets, firstIndex, minBp, bpRange, debug) => {
  if (!val) {
    return ''
  }

  const [propValue, propType] = getPropValue(key, val, presets)
  if (!Array.isArray(propValue)) {
    return ''
  }

  const min = parseProp(propValue[firstIndex], key)
  const max = parseProp(propValue[firstIndex + 1], key)
  const range = max.value - min.value
  // if (debug) {
  //   console.log(
  //     presetGenerators[propType][key](
  //       `calc(${min.value}${min.unit} + ${range} * ((100vw - ${minBp.value}${minBp.unit}) / ${bpRange}))`
  //     )
  //   )
  // }
  return presetGenerators[propType][key](
    `calc(${min.value}${min.unit} + ${range} * ((100vw - ${minBp.value}${minBp.unit}) / ${bpRange}))`
  )
}

const getBaseProps = (props, presets, debug) => {
  // if (debug) {
  //   console.log(props)
  // }
  const propKeys = Object.keys(props)
  return propKeys.reduce((res, key) => {
    return `${res}${getProp(key, props[key], presets, 0, debug)}`
  }, '')
}

const getFluidQueries = (breakpoints, props, presets, debug) => {
  const propKeys = Object.keys(props)
  const result = []
  const lastIndex = breakpoints.length - 1
  for (let i = 0; i < breakpoints.length; i++) {
    const minBp = parseProp(breakpoints[i])
    const maxBp = parseProp(breakpoints[i + 1])
    const bpRange = maxBp.value - minBp.value
    result.push(`@media screen and (min-width: ${minBp.value}${minBp.unit}){
      ${propKeys.reduce((res, key) => {
        return `${res}${
          i !== lastIndex
            ? getFluidProp(key, props[key], presets, i, minBp, bpRange, debug)
            : getProp(key, props[key], presets, i, debug)
        }`
      }, '')}
    }`)
  }
  return result.join('\n')
}

export const fluidSystem = ({ theme, children, debug, ...props }) => {
  const { breakpoints, ...presets } = theme
  if (debug) {
    // console.log(presets)
  }
  return `
  ${getBaseProps(props, presets, debug)}
  ${getFluidQueries(breakpoints, props, presets, debug)}
  `
}
